import { Microfrontend } from '@cian/mf-react';
import { type JsonObject } from '@cian/mf-react/shared/types/json';

import { type FC } from 'react';

import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { useFiltersSelector } from '@/packages/redux-state/store/slices/jsonQuery';
import { useUserIsAgentSelector } from '@/packages/redux-state/store/slices/user';

import { FiltersLayout } from '../../components/FiltersLayout';
import { useElementsRefContext } from '../../context/ElementsRefContext';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';

import { useFiltersMicrofrontend, useSaveSearchModal, useTooltipDisabled } from './hooks';

export const FiltersContainer: FC = () => {
  const manifest = useFiltersMicrofrontend();

  const isTooltipDisabled = useTooltipDisabled();

  const { open, onModalClose, onModalOpen, onSubscribed, subscribeToPush } = useSaveSearchModal();

  const isAgent = useUserIsAgentSelector();

  const { data } = useSearchOffersDesktopQuery();

  const adfoxPuids = data?.pages[0].adfox.params;

  const { filtersRef } = useElementsRefContext();

  const jsonQuery = useFiltersSelector();

  return (
    <FiltersLayout ref={filtersRef}>
      {manifest && (
        <Microfrontend
          image={manifest.image}
          instance={manifest.instance}
          name={manifest.name}
          parameters={{
            searchMetaTooltipEnabled: !isTooltipDisabled,
            adfoxPuids: adfoxPuids as unknown as JsonObject,
            professionalSearchAvailable: isAgent,
            jsonQuery: jsonQuery as unknown as JsonObject,
          }}
          runtime={manifest.runtime}
        />
      )}
      <SaveSearchModalContainer
        isOpen={open}
        onClose={onModalClose}
        onOpen={onModalOpen}
        onPushSubscribed={subscribeToPush}
        onSubscribed={onSubscribed}
      />
    </FiltersLayout>
  );
};
